export enum FecAccountMappingStatus {
  Existing = 'existing',
  New = 'new',
}
